import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "auth-main-content m-0 p-0 overflow-hidden vh-100 d-flex justify-content-center align-items-center" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-md-6 col-lg-5 col-xl-4" }
const _hoisted_5 = { class: "card bg-white border-0 rounded-3 p-4 p-sm-5" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger fs-14 py-2"
}
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-center mb-4" }, [
              _createElementVNode("h2", { class: "fw-bold text-primary mb-2" }, "Rayacheck Admin"),
              _createElementVNode("p", { class: "text-secondary" }, "Sign in to your account to continue")
            ], -1)),
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
            }, [
              (_ctx.errorMsg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorMsg), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Email address", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  placeholder: "admin@jurnalku.com",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Password", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  placeholder: "••••••••",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ])
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary w-100 py-2 fs-15 fw-medium",
                disabled: _ctx.loading
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Signing in...' : 'Sign In'), 1)
              ], 8, _hoisted_9)
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}